const min = arr => {
  if (!arr) {
    return 0
  }
  let filtered = arr.filter(i => i || i === 0 || i === '0')
  return Math.min(...filtered)
}

export { min }
